/* eslint-disable */



var loading = false,
    lastUrl = null,
    urlParams = {};

function loadContent(url, params, cb, isSubTab) {
  loading = true;
  $.ajax({
    url: paramsToURL(url, params, isSubTab),
    data: {},
    success: function(res) {
      loading = false;
      urlParams = $.extend(urlParams, params);
      cb(null, res);
    },
    error: function(res) {
      loading = false; cb('cannot fetch URL', res);
    }
  });
}

function paramsToURL(url, params, isSubTab){
    isSubTab = isSubTab || false;
    var urlFile = 'ajax.html'; 
    if(isSubTab || url.indexOf(urlFile) < 0){
        return (params) ? url + '?' + $.param(params) : url;
    }
    
    var finalURL = '';
    if(params){
        finalURL = url.replace(urlFile, '');
        for (var param in params) {
            if (params.hasOwnProperty(param)) {
                finalURL += param + '/' + params[param] + '/';
            }
        }
        finalURL += urlFile;
    }
    return finalURL;
}

function loadReevooScript(src, changeParameter, loadReviewsPage, openTab) {
  window.addEventListener('load', (event) => {
    var script = document.createElement('script');
    script.src = src;
    script.setAttribute('defer', '');
    document.body.appendChild(script);
    var scriptLoader = setInterval(function () {
      if (typeof window.ReevooEmbedded === 'undefined') return;
      window.ReevooEmbedded.changeParameter = changeParameter;
      window.ReevooEmbedded.loadReviewsPage = loadReviewsPage;
      window.ReevooEmbedded.openTab = openTab;
      clearInterval(scriptLoader);
    }, 300);
  })
}


module.exports = function(settings) {
  var container = $(settings.contents);
  var tabs = container.find('.tabs a');
  var contents = container.find('.tabs-contents .in');
  var loader = container.find('.loader');
  if (tabs.length !== 0){
    lastUrl = tabs[0].getAttribute('href');
  }

  function changeParameter(type, value) {
    container.addClass('reevoo-loading');
    urlParams[type] = value;
    if(urlParams.iPage !== undefined && (type === 'filter' || type === 'sort_by')){
        delete urlParams.iPage;
    }
    if (window.scrollY > container.offset().top) {
      $('html, body').stop().animate({ 
        scrollTop : container.offset().top + 5
      });
    }
    loadContent(lastUrl, urlParams, loadContentCallback);
  }

  function loadReviewsPage(page) {
    changeParameter('iPage', page);
  }

  function openTab(int) {
    tabs[int-1].click();
  }

  function loadContentCallback(err, res) {
    if (err) return console.log('Error on fetching: ' + res);
    contents.html(res);
    container.removeClass('reevoo-loading');
  }

  tabs.click(function(e) {
    var tab = $(this);
    e.preventDefault();
    if (loading || tab.hasClass('active')) return;

    tabs.not(tab).removeClass('active');
    tab.addClass('active');
    container.addClass('reevoo-loading');
    lastUrl = tab.attr('href');
    urlParams = {};
    loadContent(lastUrl, null, loadContentCallback, true);
  });

  loadReevooScript(settings.scriptUrl, changeParameter, loadReviewsPage, openTab);
};
